var map = {
	"./arrowDown.svg": 882,
	"./arrowLeft.svg": 760,
	"./arrowRight.svg": 146,
	"./arrowUp.svg": 36,
	"./calendar.svg": 366,
	"./clock.svg": 98,
	"./closeBig.svg": 194,
	"./closeBigWhite.svg": 576,
	"./doc.svg": 823,
	"./docx.svg": 965,
	"./download.svg": 527,
	"./error.svg": 414,
	"./file.svg": 25,
	"./folder.svg": 278,
	"./gallery.svg": 32,
	"./info.svg": 415,
	"./menu.svg": 54,
	"./pdf.svg": 606,
	"./pencil.svg": 447,
	"./ppt.svg": 757,
	"./pptx.svg": 735,
	"./remove.svg": 980,
	"./resetBlue.svg": 58,
	"./resetWhite.svg": 258,
	"./search.svg": 993,
	"./tick.svg": 556,
	"./trash.svg": 493,
	"./upload.svg": 341,
	"./uploadPlus.svg": 525,
	"./warn.svg": 232,
	"./www.svg": 41,
	"./zoom.svg": 385
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 353;